import { getLineGraphFormat, getRandomUniqueColor } from "./format-utils";
import {
  CONSTANTS,
  GRAPH_TYPES,
  REPORT_TYPES,
  VERTICALS,
} from "../../../constants/app-constant";
import { groupBy } from "../../../utility/common-methods";
import { formatDataByTrend } from "./format-data-by-trend";
const { AREA } = GRAPH_TYPES;
const {
  TonalityCCMTrend,
  TonalityNAOTrend,
  StateWiseTrend,
  TonalityMAVTrend,
  TonalityWCTrend,
  TonalityNAORanking,
  JournalistTonalityNOARanking,
  CityWiseTonality,
  StateWiseTonality
} = REPORT_TYPES;
const {
  REPORTS: { TYPES },
} = CONSTANTS;

export const formatDataByTonality = (
  d = [],
  graph_type,
  isLineGraph,
  type,
  report_type
) => {
   console.log("line no 33 ", report_type === TonalityNAOTrend ||
    report_type === StateWiseTrend ||
    report_type === TonalityCCMTrend ||
    report_type === TonalityMAVTrend ||
    report_type === TonalityWCTrend)
  if (
    report_type === TonalityNAOTrend ||
    report_type === StateWiseTrend ||
    report_type === TonalityCCMTrend ||
    report_type === TonalityMAVTrend ||
    report_type === TonalityWCTrend
  ) {
    return formatDataByTrend(d, graph_type, isLineGraph, type, report_type);
  }
  try {
    const reportType = TYPES.filter((t) => t.id == report_type)[0];
    console.log("line no 49 ",reportType)
    const {
      graphDataType: { print, online,tv },
    } = reportType;
    //const rType = type === VERTICALS.V_PRINT ? print : online;
    const rType = (type === VERTICALS.V_PRINT ? print: (type ===  VERTICALS.V_ONLINE ? online : tv));
    console.log("line no 54 ",d,rType)
    let dataByReportType = d[rType] && d[rType].returnData;
    // console.log
    const tonalities = CONSTANTS.TONALITY.map((e) => e.text);
    const color = CONSTANTS.TONALITY.map((e) => e.color);
       console.log("line 52",dataByReportType)
    const groupedDataByName = groupBy(dataByReportType, (type === VERTICALS.V_TV ? "entity_name" : "entity")) || {};
    console.log("line 53",groupedDataByName)
    const listOfEntities = Object.keys(groupedDataByName);
    const labels = isLineGraph
      ? getLineGraphFormat(listOfEntities, true)
      : listOfEntities;

    const datasets = CONSTANTS.TONALITY.map(({ tonality, articlecnt, id }, index) => {
      const data = listOfEntities.map((entity) => {
        const entObjArray = groupedDataByName[entity];

        if (
          report_type === TonalityNAORanking ||
          report_type === JournalistTonalityNOARanking ||
          report_type === CityWiseTonality ||
          report_type === StateWiseTonality 
        ) {
          const entForTone =
            entObjArray.filter((ent) => ent.tonality_id == id)[0]
          return entForTone ? parseFloat(entForTone["articlecnt"]) : 0;

        }
        else {
          const entForTone =
            entObjArray.filter((ent) => ent.entity === entity)[0] || {};
          return (entForTone && entForTone[tonality]) || 0;
        }
      });
      const lbl = tonalities[index];
      return {
        data: isLineGraph ? getLineGraphFormat(data) : data,
        //https://webonise.atlassian.net/browse/CB-614
        label: lbl == "Informative" ? "Neutral" : lbl,
        backgroundColor:
          graph_type === AREA && typeof window.Color === "function"
            ? window.Color(color[index]).alpha(0.5).rgbString()
            : color[index],
        borderColor: color[index],
        borderWidth: 1,
        fill: graph_type === AREA ? "start" : false,
        lineTension: 0,
        minBarLength: 1,
      };
    });
    return {
      datasets,
      labels,
    };
  } catch (e) {
    return {
      datasets: [],
      labels: [],
    };
  }

};
